export const getPersonaAudience = (state: any) => state.persona.persona.personaAudience;
export const getContentType = (state: any) => state.persona.persona.contentType;
export const getVeevaSpecialties = (state: any) => state.persona.persona.veevaSpecialties;
export const getPersonaList = (state: any) => state.persona.persona.personaAudienceList;
export const getPersonaGroupList = (state: any) => state.persona.persona.personaGroupList;
export const getCountry = (state: any) => state.persona.persona.country;
